<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <h5 class="mb-0"><i class="fa fa-fw fa-ticket mr-2" />Detail Shopping Cart</h5>
            <hr />
            <b-row>
                <b-col md="6">
                    No. Request <strong>{{ data.no_request }}</strong><br />
                    Nama Customer <strong>{{ data.customer_name }}</strong><br />
                    Nama Toko <strong>{{ data.customer_shop_name }}</strong><br />
                    Kontak Customer <strong>{{ data.customer_phone }}</strong><br />
                    Tanggal Request: <strong>{{ $helper.parseDate(data.created_at) }}</strong>
                </b-col>
                <b-col md="6" class="text-right">
                    <b-button variant="dark" @click="downloadExcel()">
                        <i class="fa fa-download mr-2" />Download
                    </b-button>
                </b-col>
            </b-row>
            <hr />
            <div class="brand-card-body" style="padding: 0">
                <div>
                    <div class="text-value">{{ data.total_item }}</div>
                    <div class="text-uppercase text-muted small">Total Item</div>
                </div>
                <div>
                    <div class="text-value">Rp. {{ $helper.formatThousand(data.total_price) }}</div>
                    <div class="text-uppercase text-muted small">Total</div>
                </div>
            </div>
            <hr />
            <b-row class="mt-3">
                <b-col md="4">
                    <b-form-group label="Pencarian No. Faktur">
                        <b-form-input v-model="filterInput" maxlength="50" />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-table bordered hover show-empty no-local-sorting
                :items="data.items"
                :fields="fields"
                :filter="filterInput"
                :filter-included-fields="['no_faktur_pgi']"
                responsive
                @sort-changed="onSortChanged"
            >
                <template v-slot:empty>
                    Shopping Cart kosong.
                </template>
                <template v-slot:cell(barang)="row">
                    {{ row.item.item_type }}
                    <div class="small text-muted">
                        {{ row.item.item_kind }} - {{ row.item.item_brand }}
                    </div>
                </template>
                <template v-slot:cell(noFaktur)="row">
                    NF : {{ row.item.no_faktur_pgi }}
                    <br/>
                    IMEI : {{ row.item.imei_sn }}
                    <div class="small text-muted">
                        Grade <strong>{{ row.item.grade }} - {{ row.item.item_spec }}</strong><br />
                        <strong v-if="row.item.is_batangan == 0">Lengkap</strong>
                        <strong v-else>Batangan</strong>
                    </div>
                </template>
                <template v-slot:cell(kerusakan)="row">
                    <div v-if="row.item.note_kerusakan">{{ row.item.note_kerusakan }}</div>
                    <div v-else>-</div>
                </template>
                <template v-slot:cell(price)="row">
                    Rp. {{ $helper.formatThousand(row.item.catalog_price) }}
                </template>
            </b-table>
        </b-card>
        <b-modal id="m-download" title="Data Shopping Cart" centered no-close-on-backdrop no-close-on-esc hide-footer>
            <div v-if="status == 0">
                Menyiapkan file Excel, mohon menunggu...
            </div>
            <div v-else-if="status == -1">
                Gagal menyiapkan file Excel.
            </div>
            <div v-else>
                File Excel sudah siap. Tekan tombol dibawah ini untuk download file Excel.
                <div class="mt-2">
                    <a :href="$BASE_FILE_PATH + path" download>
                        <b-button variant="primary">
                            <i class="fa fa-download mr-2" />Download Data Shopping Cart
                        </b-button>
                    </a>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>

export default {
    components: {

    },
    data() {
        return {

            initStatus: 0,
            isSubmitting: false,

            filterInput: "",

            data: {
                items: []
            },

            fields: [
                { key: "barang", label: "Barang", sortable: true },
                { key: "noFaktur", label: "No. Faktur / IMEI", sortable: true },
                { key: "kerusakan", label: "Kerusakan", sortable: true},
                { key: "price", label: "Harga", sortable: true }

            ],
            
            sortBy: null,
            sortDesc: false,

            status: 0,
            cartId: 0,
            noRequest: "",

        }
    },

    watch: {

    },

    methods: {

        init() {

            this.initStatus = 0

            let getData = this.getItems()

            Promise.all([getData]).then(() => {
                this.cartId = this.$route.params.id
                this.noRequest = this.data.no_request
                this.initStatus = 1
            })
            .catch(error => this.initStatus = -1)

        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy
            this.sortDesc = ctx.sortDesc
            this.getItems()
        },

        getItems() {
            let param = ""
            if(!this.$helper.isBlank(this.sortBy)) {
                param += "?sortBy=" + this.sortBy
                param += "&sortDesc=" + this.sortDesc
            }
            return this.$axios.get("shopping-cart/detail/" + this.$route.params.id + param).then(res => {

                let data = res.data.data
                this.data = data

            })
            .catch(error => this.$helper.parseError(this, error))
        },

        downloadExcel() {

            this.$bvModal.show("m-download")
            this.status = 0

            let payload = {
                "noRequest": this.noRequest,
                "cartId": this.cartId
            }
            this.$axios.post("shopping-cart/download-excel", payload).then(res => {

                this.status = 1
                this.path = res.data.data.path

            })
            .catch(error => {
                this.status = -1
                this.$helper.parseError(this, error)
            })
        },

    },
    created() {
        this.init()
    }
}
</script>